import React from "react";
import theme from "theme";
import { Theme, Text, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"privacy-policy"} />
		<Helmet>
			<title>
				¡Bienvenidos a Fresh & Green!
			</title>
			<meta name={"description"} content={"En Fresh & Green, nos apasiona ofrecer productos frescos, saludables y llenos de sabor."} />
			<meta property={"og:title"} content={"¡Bienvenidos a Fresh & Green!"} />
			<meta property={"og:description"} content={"En Fresh & Green, nos apasiona ofrecer productos frescos, saludables y llenos de sabor."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<meta name={"msapplication-TileColor"} content={"#0CAD1C"} />
		</Helmet>
		<Components.Header3 />
		<Section font="--lead">
			<Text font="--headline2">
				Política de Privacidad
			</Text>
			<Text>
				En Fresh & Green, respetamos profundamente tu privacidad. Esta política describe cómo recopilamos, utilizamos, almacenamos y protegemos tu información personal cuando visitas nuestro sitio web o utilizas nuestros servicios.
			</Text>
			<Text font="--headline4">
				Información que Recopilamos
			</Text>
			<Text>
				Podemos recopilar los siguientes tipos de información:
				<br />
				<br />
				- Tu nombre, datos de contacto y dirección de correo electrónico.
				<br />
				- Información relacionada con tus pedidos, reservas y preferencias para nuestros servicios.
				<br />
				- Datos sobre tus interacciones con nuestro sitio web para mejorar tu experiencia.
			</Text>
			<Text font="--headline4">
				Cómo Utilizamos tu Información
			</Text>
			<Text>
				Utilizamos tu información personal para los siguientes propósitos:
				<br />
				<br />
				- Procesar tus pedidos, reservas y solicitudes.
				<br />
				- Brindarte un excelente servicio al cliente.
				<br />
				- Enviarte ofertas promocionales, boletines y actualizaciones (solo con tu consentimiento).
				<br />
				- Mejorar nuestro sitio web y servicios en función de tus comentarios y preferencias.
			</Text>
			<Text font="--headline4">
				Protección de Datos
			</Text>
			<Text>
				Tomamos la seguridad de tus datos muy en serio. Fresh & Green emplea tecnologías modernas de cifrado y almacenamiento seguro para proteger tu información contra accesos no autorizados, pérdida o divulgación.
			</Text>
			<Text font="--headline4">
				Compartir Información con Terceros
			</Text>
			<Text>
				No compartimos tu información personal con terceros, excepto en las siguientes circunstancias:
				<br />
				<br />
				- Cuando sea requerido por la ley o para cumplir con obligaciones legales.
				<br />
				- Con proveedores de servicios de confianza que nos ayuden a ofrecer nuestros servicios (por ejemplo, procesadores de pagos o socios de entrega), y solo en la medida necesaria para cumplir con tus pedidos.
			</Text>
			<Text font="--headline4">
				Tus Derechos
			</Text>
			<Text>
				Como cliente valioso, tienes los siguientes derechos con respecto a tus datos personales:
				<br />
				<br />
				- Acceder a tu información personal y solicitar una copia de la misma.
				<br />
				- Actualizar o eliminar tu información personal.
				<br />
				- Cancelar la suscripción a correos electrónicos de marketing utilizando el enlace de "Cancelar suscripción" en nuestras comunicaciones.
				<br />
				- Restringir u oponerte a ciertas actividades de procesamiento de datos.
			</Text>
			<Text font="--headline4">
				Actualización de la Política
			</Text>
			<Text>
				Lavado Express se reserva el derecho de actualizar esta política de privacidad en cualquier momento. Cualquier cambio será publicado en esta página, y te animamos a revisarla periódicamente para mantenerte informado.
			</Text>
			<Text font="--headline4">
				Contáctanos
			</Text>
			<Text>
				Si tienes alguna pregunta o inquietud sobre nuestra Política de Privacidad, no dudes en contactarnos en contact@freshfreen.com. Valoramos tu confianza y estamos comprometidos con la protección de tu información.
			</Text>
		</Section>
		<Components.Form />
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"614ce40335c5c8001f7746de"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});